import * as React from "react";
const SvgPause = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="32" height="32" {...props}>
    <path
      d="M10.6666 28V25.3333C10.6666 23.9188 11.2285 22.5623 12.2287 21.5621C13.2289 20.5619 14.5855 20 16 20H24C25.4145 20 26.771 20.5619 27.7712 21.5621C28.7714 22.5623 29.3333 23.9188 29.3333 25.3333V28"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6667 4.1709C9.52301 4.46739 8.51016 5.13525 7.78712 6.06965C7.06407 7.00405 6.67176 8.15208 6.67176 9.33357C6.67176 10.515 7.06407 11.6631 7.78712 12.5975C8.51016 13.5319 9.52301 14.1997 10.6667 14.4962"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66669 28V25.3333C2.66757 24.1516 3.06088 23.0037 3.78487 22.0698C4.50885 21.1358 5.52251 20.4688 6.66669 20.1733"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 14.6667C17.0545 14.6667 14.6666 12.2789 14.6666 9.33333C14.6666 6.38781 17.0545 4 20 4C22.9455 4 25.3333 6.38781 25.3333 9.33333C25.3333 12.2789 22.9455 14.6667 20 14.6667Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgPause;
